<template>
  <div class="modal fade" id="FinishAttendantModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Finalizar atendimento</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              
              <div class="modal-body">
                Tem certeza que deseja finalizar esse atendimento ?
              </div>

              <div class="modal-footer">
                  <button type="button" class="btn btn-secondary pt-2 pe-3 pb-2 ps-3" data-bs-dismiss="modal">Cancelar</button>
                  <button type="button" class="btn btn-primary pt-2 pe-3 pb-2 ps-3" data-bs-dismiss="modal" @click="closeAttendant">Finalizar atendimento</button>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';

export default {
  name: "FinishAttendantModal",
  computed: {
    ...mapGetters([
      "getCurrentChat"
    ])
  },
  methods: {
    ...mapActions([
      "fetchFinishAttendant"
    ]),
    closeAttendant(){
      this.fetchFinishAttendant({
        chat_id: this.getCurrentChat.id
      });
    }
  }
};
</script>